import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";
import Checkbox from "@mui/material/Checkbox";

import { getProvinces, normalizeLocationList } from "~/services/http/locations";
import {
  locationSelectMenuProps,
  locationSelectSx,
} from "components/Inputs/locationSelectProps";

export default function ProvinceMultiSelect(props) {
  const { name, value, updateValues, disabled = false } = props;
  const { t } = useTranslation();
  const [provinces, setProvinces] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getProvinces({
      params: {
        limit: 100,
      },
    }).then((response) => {
      setProvinces(
        normalizeLocationList(response).map((province) => ({
          id: province.id,
          name: province.name,
        })),
      );
      setLoading(false);
    });
  }, []);

  const selectedIds = (value ?? []).map((item) => item.value);

  const handleChange = ({ target }) => {
    const ids = target.value;
    const newValue = ids.map((id) => {
      const province = provinces.find((item) => item.id === id);
      return { value: id, label: province?.name ?? String(id) };
    });
    updateValues({ [name]: newValue });
  };

  return (
    <TextField
      id="company_kela_areas"
      select
      label={t("Valitse Kela-alueet")}
      value={selectedIds}
      name={name}
      onChange={handleChange}
      margin="dense"
      variant="outlined"
      fullWidth
      disabled={disabled || loading}
      placeholder={loading ? t("Ladataan…") : undefined}
      sx={locationSelectSx}
      slotProps={{
        select: {
          multiple: true,
          MenuProps: locationSelectMenuProps,
          renderValue: (selected) =>
            selected
              .map((id) => provinces.find((province) => province.id === id)?.name)
              .filter(Boolean)
              .join(", "),
        },
      }}
    >
      {provinces.map((province) => (
        <MenuItem key={province.id} value={province.id}>
          <Checkbox
            checked={selectedIds.indexOf(province.id) > -1}
            size="small"
            sx={{ py: 0, mr: 1 }}
          />
          {province.name}
        </MenuItem>
      ))}
    </TextField>
  );
}
